export const AddCommentInitialVal = {
  commentText: "",
};
